export default {
  serverUrl: 'https://api-staging.voopty.com/api',
  imgUrl: 'https://voopty.com/',
  oldWebAppUrl: 'https://coach.voopty.com',
  webAppUrl: 'https://voopty.com',
  recaptchaSiteKey: '6LcS4hYTAAAAAA4aq_fqxHrU47fqsZrLb4mAoOSy',
  rootUrl: {
    en_US: 'https://voopty.com',
    ru_UA: 'https://voopty.com.ua',
    uk_UA: 'https://voopty.com.ua',
  },
  bizUrl: 'https://biz-staging.voopty.com',
  DEMO_LINK: 'https://www.voopty.com/client/5d6559789c8cbd00064920b4/69f9e477b4d6e10124bb2b6a',
  googleOAuthClientId: '294739332141-m19duo0itqvgtd7uvp5b0s2eccjhp1gj.apps.googleusercontent.com',
  analytics: {
    enabled: true,
    debug: false,
    posthog: {
      apiKey: 'phc_ARfhL4kK2f2whaZ6KHWVxSXbf3f9SvhPwfpFREhGyVr5',
    },
  },
};
